import { useMemo } from 'react';
import { getPartnerCollectionScheme, InvoiceCollectionScheme } from '@mesa-labs/mesa-api/dist/types';

import { useSelector } from '../redux/hooks';

function useOnboardingCollectionScheme() {
  const partnerId = useSelector((state) => state.onboarding.partnerId);

  const collectionScheme = useMemo(
    () => (partnerId ? getPartnerCollectionScheme(partnerId) : InvoiceCollectionScheme.PARTNER),
    [partnerId],
  );

  return {
    collectionScheme,
    isDirectDebit: collectionScheme === InvoiceCollectionScheme.DIRECT_DEBIT,
  };
}

export default useOnboardingCollectionScheme;
